// Import and register all your controllers from the importmap under controllers/*

import { application } from "../shared/application";
import { registerControllers } from "stimulus-vite-helpers";

registerControllers(application, {
  ...import.meta.glob("./**/*_controller.js", { eager: true }),
  ...import.meta.glob("../shared/**/*_controller.js", { eager: true }),
});

// The manual order builder (CAL-499) renders the
// CUSTOMER checkout's address sheet, courier quote and
// table picker UNCHANGED, and those three controllers
// live under `users/`, which this entrypoint does not
// glob. Everything else the
// address stack needs (`address-autocomplete`,
// `state-selector`, `city-selector`,
// `address-field-validator`, `external-form-submitter`,
// `modal-toggle`, `checkbox-dependent`) is already
// shared.
//
// Named one by one rather than by widening the glob to
// `../users/**`: the builder reuses exactly these three,
// and a blanket import would put the whole customer
// checkout in the admin bundle for the sake of one
// page.
//
// `tip-selector` was a fourth until `manual-order-totals`
// became the single writer of the builder's total. It
// has no tip UI to run here, and two controllers writing
// one number is what that change removed.
import AddressSelectorController from "../users/address_selector_controller";
import CourierQuoteController from "../users/courier_quote_controller";
import TablePickerController from "../users/table_picker_controller";

application.register(
  "address-selector",
  AddressSelectorController
);
application.register(
  "courier-quote",
  CourierQuoteController
);
application.register(
  "table-picker",
  TablePickerController
);
